export const CARD_TOASTS = {
  SET_AS_DEFAULT: 'Default card updated!',
  CARD_ADDED: 'Card successfully added',
  ADD_ERROR_OCCURRED: 'There was a problem adding your card',
  CARD_DELETED: 'Card successfully deleted',
};
